export const getPlayKitProductDescription = (description: string) => {
  if (!description) return '';

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(description, 'text/html');
  const firstParagraph = htmlDoc.getElementsByTagName('P')[0]?.innerHTML;
  const removedBreaks = firstParagraph?.replace('<br>', '');

  return removedBreaks;
};
